export const MAX_HISTORY_LIMIT = 30;

export const SET_STORY = "SET_STORY";
export const UNDO = "UNDO";
export const REDO = "REDO";
export const SYNC_EXTERNAL_STORY = "SYNC_EXTERNAL_STORY";

export const createInitialHistoryState = (initialStory) => ({
  past: [],
  present: initialStory,
  future: [],
  canUndo: false,
  canRedo: false,
});

export const undoRedoReducer = (state, action) => {
  switch (action.type) {
    case SET_STORY: {
      const nextStory = action.payload;
      if (nextStory === state.present) {
        return state;
      }
      if (action.skipHistory) {
        return {
          ...state,
          present: nextStory,
          canUndo: state.past.length > 0,
          canRedo: state.future.length > 0,
        };
      }
      const newPast = [...state.past, state.present].slice(-MAX_HISTORY_LIMIT);
      return {
        past: newPast,
        present: nextStory,
        future: [],
        canUndo: true,
        canRedo: false,
      };
    }

    case UNDO: {
      if (state.past.length === 0) {
        return state;
      }
      const previous = state.past[state.past.length - 1];
      const newPast = state.past.slice(0, -1);
      const newFuture = [state.present, ...state.future];
      return {
        past: newPast,
        present: previous,
        future: newFuture,
        canUndo: newPast.length > 0,
        canRedo: true,
      };
    }

    case REDO: {
      if (state.future.length === 0) {
        return state;
      }
      const next = state.future[0];
      const newFuture = state.future.slice(1);
      const newPast = [...state.past, state.present].slice(-MAX_HISTORY_LIMIT);
      return {
        past: newPast,
        present: next,
        future: newFuture,
        canUndo: true,
        canRedo: newFuture.length > 0,
      };
    }

    case SYNC_EXTERNAL_STORY: {
      return {
        ...state,
        present: action.payload,
        canUndo: state.past.length > 0,
        canRedo: state.future.length > 0,
      };
    }

    default:
      return state;
  }
};
